// extracted by mini-css-extract-plugin
export var research = "research-module--research--23SgH";
export var header = "research-module--header--1zhil";
export var list = "research-module--list--rjCit";
export var item = "research-module--item--2m6eW";
export var thumb = "research-module--thumb--bBpUl";
export var date = "research-module--date--13cFL";